import {
    View,
    Text,
    Platform,
    SafeAreaView,
    TouchableOpacity,
    Button,
} from "react-native";
import React, { useEffect, useState } from "react";
import * as Notifications from "expo-notifications";
import * as Device from "expo-device";
import * as Animatable from "react-native-animatable";
import { dispatch } from "../../redux/store";
import { setExpoToken } from "../../redux/auth/authSlice";
  
  interface Notification {
    title: string;
    body: string;
  }
  
  Notifications.setNotificationHandler({
    handleNotification: async () => ({
      shouldShowAlert: false,
      shouldPlaySound: true,
      shouldSetBadge: false,
    }),
  });
  
  export default function Notification() {
    const [expoPushToken, setExpoPushToken] = useState<string | undefined>();
    const [inAppNotification, setInAppNotification] =
      useState<Notification | null>(null);
  
    useEffect(() => {
      registerForPushNotificationsAsync()
        .then((token) => {
          dispatch(setExpoToken(token))
          setExpoPushToken(token);
        })
        .catch((err) => {
          console.log(err);
        });
  
      // Add a listener for foreground notifications
      const foregroundNotificationListener =
        Notifications.addNotificationReceivedListener((notification) => {
          setInAppNotification({
            title: notification.request.content.title || "Default Title",
            body: notification.request.content.body || "Default Body",
          });
  
          // Automatically dismiss the in-app notification after 3 seconds
          setTimeout(() => {
            setInAppNotification(null);
          }, 3200);
        });
  
      // Clean up the listener when the component unmounts
      return () => {
        if (foregroundNotificationListener) {
          foregroundNotificationListener.remove();
        }
      };
    }, []);

  }
  
  export async function registerForPushNotificationsAsync() {
    let token;
    
    if (Platform.OS === "android") {
      await Notifications.setNotificationChannelAsync("default", {
        name: "default",
        importance: Notifications.AndroidImportance.MAX,
        vibrationPattern: [0, 250, 250, 250],
        lightColor: "#FF231F7C",
      });
    }
  
    if (Device.isDevice) {
      const { status: existingStatus } =
      await Notifications.getPermissionsAsync();
      let finalStatus = existingStatus;
      if (existingStatus !== "granted") {
        const { status } = await Notifications.requestPermissionsAsync();
        finalStatus = status;
      }
      // if (finalStatus !== "granted") {
      //   alert("Failed to get push token for push notification!");
      //   return;
      // }
      // Learn more about projectId:
      // https://docs.expo.dev/push-notifications/push-notifications-setup/#configure-projectid
      token = (
        await Notifications.getExpoPushTokenAsync({
          projectId: "e4e5c141-37b0-4e2e-b5ca-2b29c3a50381",
        })
      ).data;
      // console.log(token);
    } else {
      alert("Must use physical device for Push Notifications");
    }
  
    return token;
  }